var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "TshirtAdd",

    getDefaultProps () {
        return {"width":"22px","height":"22px","viewBox":"0 0 22 22","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>Icon/T-Shirt Add 2</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Icon/T-Shirt-Add-2" fill="#000000">
      <g id="T-Shirt-Add-2">
        <path d="M11.9416012,1.59200246 L18.2353133,4.39414364 L16.6083667,8.04832547 L14,6.88700579 L14,14 L4,14 L4,6.99177401 L1.62694657,8.04832547 L2.68141065e-12,4.39414364 L6.079152,1.68753079 C6.38995367,3.01302943 7.57971717,4 9,4 C10.4541989,4 11.6667376,2.96532925 11.9416012,1.59200246 Z" id="Combined-Shape-Copy"/>
        <rect id="Rectangle-4" x="12" y="16" width="10" height="2"/>
        <rect id="Rectangle-4-Copy-6" x="16" y="12" width="2" height="10"/>
      </g>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/ui/images/T-ShirtAdd.svg